// extracted by mini-css-extract-plugin
module.exports = {"bannerMB120":"style_bannerMB120__10qEC","mdDownNone":"style_mdDownNone__33OoB"};